import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, of } from 'rxjs';
import { ApiCollectionResponse } from '@shared/types/api/api-collection-response';
import { Country, CountryDto, parseToCountry } from '@shared/services/country/types/country.type';
import { PageableFetchOptions } from '@shared/types/api/pageable-options.type';

export interface Region {
  iso2: string;
  name: string;
}
@Injectable({ providedIn: 'root' })
export class LocationService {
  private readonly _httpClient: HttpClient = inject(HttpClient);

  public getCountries (options?: PageableFetchOptions): Observable<ApiCollectionResponse<Country>> {
    const fields: Array<keyof CountryDto> = [ "isoNum", "iso2", "name" ];
    const sort: keyof CountryDto = "name";

    let params: HttpParams = new HttpParams()
      .set("offset", options?.offset ?? 0)
      .set("limit", options?.limit ?? 30)
      .set("fields", fields.join(","))
      .set("sort", sort);


    if (options?.searchTerm)
      params = params.set("fulltext", options.searchTerm);


    return this._httpClient.get<ApiCollectionResponse<CountryDto>>("api/countries", { params })
      .pipe(
        map((response: ApiCollectionResponse<CountryDto>) => ({
          ...response,
          data: response.data
            .map(parseToCountry)
        }))
      );
  }

  public getRegions (countryIsoCodeTwo: string, options?: PageableFetchOptions): Observable<ApiCollectionResponse<Region>> {
    const fields: Array<keyof CountryDto> = [ "iso2", "name" ];
    const sort: keyof CountryDto = "name";

    let params: HttpParams = new HttpParams()
      .set("offset", options?.offset ?? 0)
      .set("limit", options?.limit ?? 30)
      .set("fields", fields.join(","))
      .set("sort", sort);

    if (options?.searchTerm)
      params = params.set("fulltext", options.searchTerm);

    return this._httpClient.get<ApiCollectionResponse<CountryDto>>(`api/countries/${ countryIsoCodeTwo }/regions`, { params });
  }

  public loadRegions (countryCode: string): Observable<Region[]> {
    const url: string = `/api/countries/${ countryCode }/regions?fields=iso2%2Cname&sort=name&limit=25&page=1&offset=0`;

    return this._httpClient.get<{ data: Array<{ iso2: string; name: string; }>; }>(url).pipe(
      // eslint-disable-next-line @tseslint/typedef
      map((res) => res.data.map((r) => ({ iso2: r.iso2, name: r.name }))),
      catchError(() => of([]))
    );
  }
}
